import { Component, inject, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

import { AuthService } from '@core/services/auth';
import { Breadcrumb } from '@components/breadcrumb/breadcrumb';
import { EnvironmentBadge } from '@components/environment-badge/environment-badge';
import { UserMenu } from '@components/user-menu/user-menu';

@Component({
  selector: 'yt-topbar',
  imports: [RouterModule, ButtonModule, Breadcrumb, EnvironmentBadge, UserMenu],
  templateUrl: './topbar.html',
  styleUrl: './topbar.scss'
})
export class Topbar {
  private readonly authAPIs = inject(AuthService);

  readonly isUserAuthenticated = input<boolean>();
  readonly sidebarToggle = output<void>();

  protected login(): void {
    this.authAPIs.login();
  }
}
